import type { List } from "~/types/custom"
import { LordIconSource, LordIconTrigger, Iconify } from "~/types/assets";
import IconLord from '~/components/icon/Lord.vue'

export const frontend: List = [
  {
    id: 0,
    title: 'Nuxt3',
    iconComponent: markRaw(
      defineComponent({
        /* @ts-expect-error type mismatch */
        render: () => <Icon name={Iconify.nuxt} />,
      }),
    ),
  },
  {
    id: 1,
    iconComponent: markRaw(
      defineComponent({
        render: () => <IconLord
          src={LordIconSource.plus}
          trigger={LordIconTrigger.loop}
          revert={true}
          delay={500}
          size="w-10 h-10 lg:w-[4rem] lg:h-[4rem]"
        />
      }),
    ),
  },
  {
    id: 2,
    title: 'TailwindCSS 5',
    iconComponent: markRaw(
      defineComponent({
        /* @ts-expect-error type mismatch */
        render: () => <Icon name={Iconify.tailwind} />,
      }),
    ),
  },
  {
    id: 3,
    iconComponent: markRaw(
      defineComponent({
        render: () => <IconLord
          src={LordIconSource.plus}
          trigger={LordIconTrigger.loop}
          revert={true}
          delay={500}
          size="w-10 h-10 lg:w-[4rem] lg:h-[4rem]"
        />
      }),
    ),
  },
  {
    id: 4,
    title: 'Typescript',
    iconComponent: markRaw(
      defineComponent({
        /* @ts-expect-error type mismatch */
        render: () => <Icon name={Iconify.typescript} />,
      }),
    ),
  },
]

export const backend: List = [
  {
    id: 5,
    title: 'SQLite3',
    iconComponent: markRaw(
      defineComponent({
        /* @ts-expect-error type mismatch */
        render: () => <Icon name={Iconify.sqlite} />,
      }),
    ),
  },
  {
    id: 6,
    iconComponent: markRaw(
      defineComponent({
        render: () => <IconLord
          src={LordIconSource.plus}
          trigger={LordIconTrigger.loop}
          revert={true}
          delay={500}
          size="w-10 h-10 lg:w-[4rem] lg:h-[4rem]"
        />
      }),
    ),
  },
  {
    id: 7,
    title: 'Prisma',
    iconComponent: markRaw(
      defineComponent({
        /* @ts-expect-error type mismatch */
        render: () => <Icon name={Iconify.prisma} />,
      }),
    ),
  },
  {
    id: 8,
    iconComponent: markRaw(
      defineComponent({
        render: () => <IconLord
          src={LordIconSource.plus}
          trigger={LordIconTrigger.loop}
          revert={true}
          delay={500}
          size="w-10 h-10 lg:w-[4rem] lg:h-[4rem]"
        />
      }),
    ),
  },
  {
    id: 9,
    title: 'Nitro',
    iconComponent: markRaw(
      defineComponent({
        /* @ts-expect-error type mismatch */
        render: () => <Icon name={Iconify.nuxt} />,
      }),
    ),
  },
]
